/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconHistoryOff = createSolidComponent("history-off", "IconHistoryOff", [
  [
    "path",
    {
      d: "M3.05 11a8.975 8.975 0 0 1 2.54 -5.403m2.314 -1.697a9 9 0 0 1 12.113 12.112m-1.695 2.312a9 9 0 0 1 -14.772 -3.324m-.5 5v-5h5"
    }
  ],
  ["path", { d: "M3 3l18 18" }]
]);

export { IconHistoryOff as default };
//# sourceMappingURL=IconHistoryOff.js.map
